import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ds/Button';
import Icon from '../lib/Icon';
import AccountMenu from './AccountMenu';
import { useUser } from '../../contexts/ContextUser';
import { roleFor, ROLE_META } from '../lib/access';

function RoleChip({ user }) {
  const role = roleFor(user);
  const meta = ROLE_META[role];
  return (
    <span title={meta.sub} style={{
      display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 12px',
      background: 'var(--neutral-50)', border: '1px solid var(--line)', borderRadius: 'var(--radius-pill)',
      fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-xs)',
      letterSpacing: 'var(--track-tight)', color: 'var(--ink-soft)',
    }}>
      <Icon name={meta.icon} size={13} />
      {meta.label}
    </span>
  );
}

export default function Topbar() {
  const { user } = useUser();
  const navigate = useNavigate();
  return (
    <div className="cc-no-print" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 36px',
      borderBottom: '1px solid var(--line)', background: 'rgba(255,255,255,0.85)',
      backdropFilter: 'blur(8px)', position: 'sticky', top: 0, zIndex: 20,
    }}>
      <div>
        <div className="cc-eyebrow" style={{ fontSize: 10 }}>Workspace</div>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-lg)', letterSpacing: 'var(--track-tight)' }}>
          {user.account && user.account.name}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <RoleChip user={user} />
        <span style={{ width: 1, height: 26, background: 'var(--line)' }} />
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 8, height: 40, padding: '0 14px',
          border: '1px solid var(--line)', borderRadius: 'var(--radius-pill)',
          color: 'var(--ink-muted)', fontSize: 'var(--text-sm)',
        }}>
          <Icon name="search" size={16} />
          Search engagements
        </span>
        <a href="/notifications" aria-label="Notifications" style={{
          display: 'inline-flex', width: 40, height: 40, alignItems: 'center', justifyContent: 'center',
          border: '1px solid var(--line)', borderRadius: 'var(--radius-pill)', color: 'var(--ink-soft)',
        }}>
          <Icon name="bell" size={18} />
        </a>
        <Button variant="primary" iconLeft={<Icon name="plus" size={18} />} onClick={() => navigate('/console/new')}>
          New engagement
        </Button>
        <AccountMenu user={user} />
      </div>
    </div>
  );
}
